// extracted by mini-css-extract-plugin
export default {"darkModeSlider":"Settings_darkModeSlider__EQeYE"};